// src/context/LanguageContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

export const useLanguage = () => {
  return useContext(LanguageContext);
};

export const LanguageProvider = ({ children }) => {
  const [selectedLanguage, setSelectedLanguage] = useState(() => {
    const sessionLanguage = sessionStorage.getItem('language');
    const savedLanguage = localStorage.getItem('language');

    // Se há idioma salvo na sessionStorage, usamos ele. Caso contrário, usamos o idioma do localStorage
    if (sessionLanguage) {
      return sessionLanguage; // Mantém durante a mesma sessão
    }

    // Se não houver idioma salvo no sessionStorage, reinicia para 'pt' para nova sessão
    return savedLanguage || 'pt'; // Se não houver nada salvo, retorna 'pt' por padrão
  });

  const changeLanguage = (newLang) => {
    setSelectedLanguage(newLang);
    sessionStorage.setItem('language', newLang);
    localStorage.setItem('language', newLang);
  };

  useEffect(() => {
    // Verifica se é a primeira vez na sessão, se não, mantém o idioma salvo no localStorage
    const sessionLanguage = sessionStorage.getItem('language');
    if (!sessionLanguage) {
      // Se sessionStorage estiver vazio, define o idioma como 'pt'
      sessionStorage.setItem('language', 'pt');
      setSelectedLanguage('pt');
    }
  }, []);

  return (
    <LanguageContext.Provider value={{ selectedLanguage, changeLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};